module.exports = __webpack_public_path__ + "assets/img/6c163b72cb5c973e3e5decf7c95973ba.png";